export const colors = {
  backgroundGreen: "#E9FFD6",
  lightGreen: "#3DB850",
  darkGreen: "#092B00",
};
